import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
export default {
  data() {
    return {
      setLoading: false,
      setNameInfo: {
        show: false
      },
      showFullScreen: false
    };
  },
  props: {
    anywherePopShow: Boolean,
    isAnyWhere: Boolean,
    movePips: {
      type: Object,
      default: () => {
        return {};
      }
    },
    tagNameInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    allRList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    index: {
      type: Number,
      default: 1
    },
    stream: {
      type: Object,
      default: function () {
        return {};
      }
    },
    questionerInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    rtilCode: {
      default: ''
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    rtc: {
      type: Object,
      default: function () {
        return {};
      }
    },
    degreeHost: {
      type: [String, Number],
      default: 0
    },
    volume: {
      type: Object,
      default: function () {
        return {
          level: 0
        };
      }
    },
    isAudioLevel: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.onresize = () => {
      this.setVideoWidths();
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      PrivateInfo: state => state.privateInfo,
      logoGray: state => state.logoGray
    }),
    judgeEarphone() {
      let flag = true;
      if (this.PrivateInfo && this.PrivateInfo.rtilCode == this.questionerInfo.rtilCode) {
        flag = false;
      }
      return flag;
    },
    hearVoice() {
      let flag = true;
      if (this.PrivateInfo && this.PrivateInfo.rtilCode == this.questionerInfo.rtilCode) {
        flag = false;
      }
      return flag;
    },
    operateList() {
      let array = [];
      if (this.PrivateInfo.rtilCode == this.questionerInfo.rtilCode) {
        array = ['fullScreen', 'rename', 'editTagName', 'setPublicTalk', 'cancelPrivateConversation', 'moveParty', 'cancelQuestionerRemove'];
      } else {
        array = ['fullScreen', 'rename', 'editTagName', 'setPublicTalk', 'startPrivateConversation', 'moveParty', 'cancelQuestionerRemove'];
      }
      if (this.questionerInfo.rtilCode == this.userInfo.rtilCode) {
        array = ['fullScreen', 'rename', 'setPublicTalk', 'cancelQuestionerRemove'];
      }
      if (this.index - 1) array.unshift('toTop');
      // 获取可以move的所有rtilcode
      if (array.includes('moveParty') && this.questionerInfo.rtilCode && !this.State.batchMoveParticipateList.includes(this.questionerInfo.rtilCode)) {
        this.State.batchMoveParticipateList.push(this.questionerInfo.rtilCode);
      }
      // 移除anyWhere中的setting
      if (this.isAnyWhere) {
        array.push('anyWhereSetting');
      }
      return array;
    }
  },
  methods: {
    moveParty(val, rtilCode) {
      this.attendCallback({
        type: 'moveParty',
        id: rtilCode,
        status: val,
        sign: 'batch'
      });
    },
    attendCallback(obj) {
      const {
        type,
        rtilCode,
        val
      } = obj;
      if (type == 'toTop') {
        this.changeToTop(rtilCode);
      }
      if (type == 'setPublicTalk' || type == 'setQuestionSpeaker') {
        this.setQuestionSpeaker();
      }
      if (type == 'cancelQuestionerRemove') {
        this.removeQuestioner();
      }
      if (type == 'muteAudio' || type == 'muteVideo' || type == 'editTagName' || type == 'moveParty' || type == 'anyWhereSetting') {
        this.$emit('callbackAttend', obj);
      }
      if (type == 'fullScreen') {
        this.showFullScreen = val;
        this.$emit('callback', {
          type: 'fullScreen',
          val,
          rtilCode: this.questionerInfo.rtilCode
        });
      }
    },
    callbackByLiveSource(obj) {
      this.$emit('callback', obj);
    },
    setVideoWidths() {
      const widthRem = 16 / 9;
      if (this.$refs.questionerVideo) {
        const height = this.$refs.questionerVideo.clientHeight;
        this.$refs.questionerVideo.style.maxWidth = height * widthRem * 4 + 2;
      }
    },
    changeToTop(rtilCode) {
      const params = {
        conferenceCode: this.State.partyCode,
        rtilCode: rtilCode
      };
      this.axios.post(`/partyline-backend/conference/toTop/${this.State.partyCode}/${rtilCode}`, params).then(res => {});
    },
    setQuestionSpeaker() {
      if (this.setLoading) return;
      this.setLoading = true;
      if (this.State.talkInfo) {
        this.cancelLastTalk();
        return;
      }
      const params = {
        partyCode: this.State.partyCode,
        module: 'setQuestionSpeaker',
        msg: {
          nickName: this.questionerInfo.nickName,
          rtilCode: this.questionerInfo.rtilCode,
          index: this.index,
          deleteIndex: true
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=5811', params).then(res => {
        setTimeout(() => {
          this.setLoading = false;
        }, 500);
      });
    },
    cancelLastTalk() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'cancelQuestionSpeaker',
        msg: {
          nickName: this.State.talkInfo.nickName,
          rtilCode: this.State.talkInfo.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=51751', params).then(res => {
        if (res.data.errorCode == '0x0') {
          this.State.talkInfo = null;
          this.setLoading = false;
          this.setQuestionSpeaker();
        }
      });
    },
    removeQuestioner() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'cancelQuestioner',
        msg: {
          nickName: this.questionerInfo.nickName,
          rtilCode: this.questionerInfo.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=86947', params);
    }
  }
};